import { CardStat } from "./CardComps"
import { CardContainer } from "./CardContainer"
import { IconButton } from "@mui/material"
import { Link } from "react-router-dom"
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded"

export const ListCourseCard = ({ data }) => {
  return (
    <>
      <CardContainer
        SummaryContent={
          <>
            <CardStat label="Name" value={data.name} />
            <CardStat label="Students" value={data.studentCount || "0"} />
            <CardStat label="Batches" value={data.noOfBatches || "0"} />
          </>
        }
        ActionButtons={
          <Link to={`/academic/courses/${data.id}`}>
            <IconButton>
              <OpenInNewRoundedIcon />
            </IconButton>
          </Link>
        }
      />
    </>
  )
}
